// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { flowTestnet as _flowTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the flowTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 545
 * Chain Name: FlowEVM Testnet
 * Default Block Explorer: https://testnet.flowdiver.io
 * Default RPC URL: https://testnet.evm.nodes.onflow.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { flowTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: flowTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const flowTestnet = createCommon({
	..._flowTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
